import React from 'react';
import { useDispatch } from 'react-redux';
import {
  performLogin as performLoginAction,
  setLoginMode,
  setPassword,
  setUsername,
} from '../../../Actions/Login.action';
import { useTypedSelector } from '../../../Hooks/useTypedSelector';
import { translate } from '../../../Services/translation';
import LoginMode from '../../../Types/LoginMode';
import Input from '../../Inputs/Input';
import clsx from 'clsx';

const LoginForm = ({ useH1 = true }: { useH1?: boolean }) => {
  const {
    isLoading,
    username = '',
    password = '',
  } = useTypedSelector((state) => state.login);
  const dispatch = useDispatch();

  const performLogin = (e?: any) => {
    if (e) {
      e.preventDefault();
    }
    dispatch(performLoginAction(username, password));
  };

  return (
    <>
      {useH1 ? (
        <h1 className="mb-2">{translate('general.login')}</h1>
      ) : (
        <h2 className="h1 mb-2">{translate('general.login')}</h2>
      )}
      <div className="mb-6 text-xl ">
        {translate('login.login-page.intro')}
      </div>
      <form onSubmit={performLogin}>
        <Input
          inputSize="xlarge"
          wrapperClassName="mb-4 [&_label]:!absolute [&_label]:!-top-2 [&_label]:!left-[14px] [&_label]:!text-sm [&_label]:!bg-white"
          label={translate('general.username')}
          showAnimatedLabel={true}
          onChange={(e) => dispatch(setUsername(e.target.value))}
          disabled={isLoading}
          autoComplete="username"
        />
        <Input
          inputSize="xlarge"
          showAnimatedLabel={true}
          wrapperClassName="[&_label]:!absolute [&_label]:!-top-2 [&_label]:!left-[14px] [&_label]:!text-sm [&_label]:!bg-white"
          label={translate('general.placeholder.password')}
          onChange={(e) => dispatch(setPassword(e.target.value))}
          disabled={isLoading}
          type="password"
          autoComplete="current-password"
        />
        <button
          type="submit"
          className={clsx(
            'mt-4',
            'btn',
            'btn--xlarge',
            'w-full',
            'btn--black'
          )}
          disabled={isLoading}
        >
          {!isLoading && translate('general.login')}
          {isLoading && translate('general.loading')}
        </button>
      </form>
      <div className="mt-6 flex flex-col items-center">
        <button
          onClick={() => dispatch(setLoginMode(LoginMode.ForgotPassword))}
          disabled={isLoading}
          className="underlined-link mx-auto mb-5 self-start text-sm uppercase after:w-full"
        >
          {translate('login.forgot-password')}
        </button>
        <button
          onClick={() => dispatch(setLoginMode(LoginMode.RegisterAccount))}
          disabled={isLoading}
          className="underlined-link mx-auto self-start text-sm uppercase after:w-full"
        >
          {translate('login.register-account')}
        </button>
      </div>
    </>
  );
};

export default LoginForm;
